import React, { createContext, useCallback, useState, useEffect, useRef } from 'react'

export const ThemeContext = createContext()

const ThemeProvider = ({ children, location }) => {
  const [siteTheme, setSiteTheme] = useState('')
  const [showSplash, setShowSplash] = useState(true)
  const scrollSmoother = useRef(null)

  const setTheme = useCallback((name) => {
    setSiteTheme(name)
  }, [])

  useEffect(() => {
    if (showSplash && location.pathname !== '/') {
      setShowSplash(false)
    }
  }, [location, showSplash, setShowSplash])

  return (
    <ThemeContext.Provider
      value={{
        siteTheme,
        setTheme,
        showSplash,
        setShowSplash,
        scrollSmoother
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
